export const KEEP_CHANGES="keep_changes";export const DISCARD_CHANGES="discard_changes";